import { usePunditUserContext } from "@circle-react/contexts";
import type { ConversationChannel } from "../types/ConversationChannel";
import { QueueBanner } from "./QueueBanner";
import { Thinking } from "./common/Thinking";
import { ThinkingCard } from "./common/copilot/ThinkingCard";

interface ConversationViewLoadingStatesProps {
  channel: ConversationChannel | null;
  copilotLoadingText: string | null;
  isBotProcessing: boolean;
  isWaitingForConfirmation: boolean;
  isWaitingInQueue: boolean;
  queuePosition: number | null;
}

export const ConversationViewLoadingStates = ({
  channel,
  copilotLoadingText,
  isBotProcessing,
  isWaitingForConfirmation,
  isWaitingInQueue,
  queuePosition,
}: ConversationViewLoadingStatesProps) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isCopilotV2Enabled = !!currentCommunitySettings?.copilot_v2_enabled;

  const isShowingCopilotThinking =
    isCopilotV2Enabled && !!copilotLoadingText && !isWaitingForConfirmation;
  const isShowingThinking = isBotProcessing && !copilotLoadingText;
  const isShowingQueue = channel === "live_chat" && isWaitingInQueue;

  return (
    <>
      {isCopilotV2Enabled && (
        <ThinkingCard
          show={isShowingCopilotThinking}
          title={copilotLoadingText}
        />
      )}
      {(isShowingThinking || isShowingQueue) && (
        <div className="mt-4 flex flex-col">
          {isShowingThinking && <Thinking />}
          {isShowingQueue && queuePosition !== null && (
            <QueueBanner queuePosition={queuePosition} />
          )}
        </div>
      )}
    </>
  );
};
